/** Meinungsthemen gruppiert: die bisherigen offen, „Gesellschaft und Werte“ (ab Regelversion 3) zum Aufklappen. */
import type { ReactNode } from 'react';
import { axes, isV3Axis } from '../engine/axes';

export function AxGroups({ render, note, open }: { render: (a: string) => ReactNode; note?: string; open?: boolean }) {
  const all = axes(), base = all.filter((a) => !isV3Axis(a)), extra = all.filter(isV3Axis);
  return <>
    {base.map(render)}
    {extra.length > 0 && <details className="axgroup" open={open}>
      <summary><b>Gesellschaft und Werte</b><span className="sub"> · {extra.length} Fragen{note ? ` · ${note}` : ''}</span></summary>
      {extra.map(render)}
    </details>}
  </>;
}
